export default __webpack_public_path__ + "static/media/wife-and-cat-lg-1x.3cd10634.jpg";